/**
 * Wraps every `<table>` in an HTML string with a `<div class="table-responsive">`
 * so wide tables can scroll horizontally instead of overflowing their container.
 *
 * This runs on the RTE HTML string during render (server and client) rather than
 * on a live DOM node, so it is a pure string transform with no DOM dependency.
 * Valid HTML forbids nesting a `<table>` inside another, so matching from an
 * opening `<table` to its first following `</table>` cannot straddle a nested
 * table and is safe for authored rich text.
 *
 * Idempotent: a table whose immediately preceding markup is an unclosed
 * `table-responsive` div is left untouched, so wrapping an already-wrapped
 * string does not nest wrappers.
 *
 * Expects HTML that has already passed through `rteContentFilter`; it does not
 * sanitize and must not be relied on for security.
 */
const tableElement = /<table\b[^>]*>[\s\S]*?<\/table>/gi

const alreadyWrapped =
  /<div\b[^>]*\bclass\s*=\s*(["'])[^"']*\btable-responsive\b[^"']*\1[^>]*>\s*$/i

export function wrapResponsiveTables(html: string): string {
  return html.replace(tableElement, (table, offset: number, source: string) => {
    const preceding = source.slice(0, offset)
    if (alreadyWrapped.test(preceding)) {
      return table
    }
    return `<div class="table-responsive">${table}</div>`
  })
}
